"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function highlight(text, search, modifier) {
    var pattern = new RegExp(search, 'i');
    var mod = (modifier && " a-highlight--" + modifier) || '';
    return (text && search) ? text.replace(pattern, "<strong class=\"a-highlight" + mod + "\">" + pattern.exec(text) + "</strong>") : text;
}
exports.highlight = highlight;
